var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFillplain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30.5,
    r: 30,
    fill: "#A855F7",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_332_28491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9796 18.5278C45.1258 17.847 44.4584 17.273 43.8073 17.5214L15.5654 28.3026C15.3994 28.366 15.2564 28.4782 15.1555 28.6245C15.0546 28.7708 15.0003 28.9442 15 29.122C14.9997 29.2997 15.0532 29.4734 15.1536 29.62C15.254 29.7667 15.3964 29.8795 15.5622 29.9435L23.4959 33.0077V42.6587C23.4959 42.8565 23.5626 43.0485 23.6852 43.2037C23.8078 43.3588 23.9792 43.4681 24.1716 43.5139C24.364 43.5596 24.5662 43.5391 24.7455 43.4557C24.9248 43.3723 25.0708 43.2308 25.1597 43.0542L28.441 36.5429L36.4486 42.4856C36.9357 42.8471 37.6358 42.6172 37.8131 42.0362C45.2895 17.5234 44.9663 18.5894 44.9796 18.5278ZM38.0081 21.6167L24.2503 31.4146L18.3307 29.1284L38.0081 21.6167ZM25.2537 32.858L37.2459 24.3176C26.9268 35.2036 27.4657 34.6306 27.4207 34.6912C27.3539 34.7812 27.537 34.4306 25.2537 38.9616V32.858ZM36.4953 40.3313L29.4468 35.1003L42.1914 21.6554L36.4953 40.3313Z",
    fill: "#A855F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_332_28491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(15 15.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillplain);
export default __webpack_public_path__ + "static/media/fillplain.2d11fe23536268cc526a3e1e001006be.svg";
export { ForwardRef as ReactComponent };